// askSmart-ui/src/pages/MapleCoin/operations/JobsPanel.tsx
//
// Scheduled jobs (C1 foundation): what is defined, recent runs, and any run
// interrupted mid-way that must be looked at by a person before its
// occurrence can run again. Read-only. No jobs are defined yet.
import { useCallback, useEffect, useState } from 'react';
import { Jobs, getJobs } from './opsApi';
import { Loading, Panel, Status, Unavailable, dateTime } from './shared';

export default function JobsPanel() {
  const [data, setData] = useState<Jobs | null>(null);
  const [state, setState] = useState<'loading' | 'ready' | 'error'>('loading');
  const load = useCallback(() => {
    setState('loading');
    getJobs().then((d) => { setData(d); setState('ready'); }).catch(() => setState('error'));
  }, []);
  useEffect(load, [load]);

  if (state === 'loading') return <Loading label="Loading scheduled jobs" />;
  if (state === 'error' || !data) return <Unavailable onRetry={load} />;
  return (
    <Panel title="Scheduled jobs">
      {data.definitions.length === 0 ? (
        <p className="mco-empty" data-testid="jobs-none">No scheduled jobs are defined. Nothing runs automatically.</p>
      ) : (
        <p className="mco-note">{data.definitions.length} job{data.definitions.length === 1 ? '' : 's'} defined.</p>
      )}
      {data.needsReview.length > 0 && (
        <p className="mco-check mco-check--bad" role="alert">
          {data.needsReview.length} interrupted run{data.needsReview.length === 1 ? '' : 's'} need review before
          {data.needsReview.length === 1 ? ' its occurrence' : ' their occurrences'} can run again.
        </p>
      )}
      {data.recentRuns.length > 0 && (
        <div className="mco-table-wrap">
          <table className="mco-table">
            <thead><tr><th>Job</th><th>Occurrence</th><th>Attempt</th><th>Status</th><th>Started</th><th>Finished</th><th>Error</th></tr></thead>
            <tbody>
              {data.recentRuns.map((r) => (
                <tr key={r.runId}>
                  <td><code>{r.jobName}</code></td>
                  <td>{dateTime(r.occurrenceAt)}</td>
                  <td className="mco-num">{r.attempt}</td>
                  <td><Status value={r.status} /></td>
                  <td>{dateTime(r.claimedAt)}</td>
                  <td>{dateTime(r.finishedAt)}</td>
                  <td>{r.errorCode ?? ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
